/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const antique_pictures : {[key: string]: Array<[string, string]>} = {
};
